'use strict';

const Format = {

    date(date) {
        date = new Date(date);
        return date.getFullYear() + '-' + (date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
    },

    time(time) {
        return time.hh + ':' + time.mm + time.A
    },

    setDateToMidnight(date) {
        if (typeof(date) == 'object') {
            date = new Date(date.setHours(0, 0, 0, 0));
          }

        return date;
    }
    
}

export default Format;